var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNovedadesInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#8a8a8a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_7",
    "data-name": "Capa 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bounding_Boxes",
    "data-name": "Bounding Boxes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2274",
    "data-name": "Trazado 2274",
    className: "cls-1",
    d: "M3.26-8.39h24v24h-24Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_22",
    "data-name": "Capa 22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2275",
    "data-name": "Trazado 2275",
    className: "cls-2",
    d: "M18.28,3.5H14.23a2.86,2.86,0,0,0-5.46,0h-4a1.58,1.58,0,0,0-.38,0,1.85,1.85,0,0,0-1,.55,2,2,0,0,0-.42.64,2,2,0,0,0-.15.77v14a2,2,0,0,0,.57,1.42,1.85,1.85,0,0,0,1,.55,2.34,2.34,0,0,0,.38,0H18.28a2,2,0,0,0,1.93-2V5.5A2,2,0,0,0,18.28,3.5ZM11.5,3.1a.67.67,0,1,1-.65.68v0a.66.66,0,0,1,.65-.66Zm6.18,16.65H5.32a.81.81,0,0,1-.81-.81V6.12a.81.81,0,0,1,.81-.81H17.68a.81.81,0,0,1,.81.81V18.94A.81.81,0,0,1,17.68,19.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_957",
    "data-name": "Rect\\xE1ngulo 957",
    className: "cls-2",
    x: 10.52,
    y: 15.03,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_958",
    "data-name": "Rect\\xE1ngulo 958",
    className: "cls-2",
    x: 10.52,
    y: 8.03,
    width: 2,
    height: 6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNovedadesInactive);
export default __webpack_public_path__ + "static/media/ic-novedades-inactive.e4709704148874771349ec5c722460a2.svg";
export { ForwardRef as ReactComponent };